var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',_vm._g(_vm._b({staticClass:"draggable-container",attrs:{"animation":200,"handle":".handle","draggable":".draggable-item","ghostClass":"ghost"}},'draggable',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }